import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "edit",
  "use": "edit-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"edit\">\r\n<g>\r\n\t<path d=\"M18.5,18h-17C1.224,18,1,18.224,1,18.5v1C1,19.776,1.224,20,1.5,20h17c0.276,0,0.5-0.224,0.5-0.5v-1\r\n\t\tC19,18.224,18.776,18,18.5,18z\" />\r\n\t<path d=\"M17.985,5.293l-4.278-4.278L2.011,12.71v4.278H6.29L17.985,5.293z M3.994,15.005v-1.43l9.583-9.583\r\n\t\tl1.43,1.43l-9.583,9.583H3.994z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol